export const getMinutes = (ms) => Math.floor(ms / (1000 * 60));

export const getOnlyMinutes = (ms) => Math.floor((ms / (1000 * 60)) % 60);

export const getOnlyHours = (ms) => Math.floor((ms / (1000 * 60 * 60)) % 24);
